import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router';
import store from './store';
import Mixin from './mixin.js';

import PrimeVue from 'primevue/config';
import Carousel from 'primevue/carousel';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";

import 'font-awesome/css/font-awesome.min.css';

import DialogService from 'primevue/dialogservice';
import DynamicDialog from 'primevue/dynamicdialog';
import ToastService from 'primevue/toastservice';
import ConfirmDialog from 'primevue/confirmdialog';
import Dropdown from 'primevue/dropdown';

import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';


createApp(App)
  .use(router)
  .use(store)
  .mixin(Mixin)

  .use(PrimeVue, { ripple: true, unstyled: false }) // Ripple is an optional animation for the supported components such as buttons.

  .use(DialogService)
  .use(ToastService)

  .component('DynamicDialog', DynamicDialog)
  .component('ConfirmDialog', ConfirmDialog)
  .component('Carousel', Carousel)
  .component('Toast', Toast)
  .component('InputText', InputText)
  .component('Textarea', Textarea)
  .component('Dropdown', Dropdown)

  .mount('#app');
